<app-form-header class="backoffice-page-header"></app-form-header>
<mat-card>
  <div class="form-box">
    <form [formGroup]="formularioAbs">

      <div class="container"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap="10px"
           fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>nombre</mat-label>
          <input matInput formControlName="nombre" type="text" placeholder="Ingrese el nombre"
                 [errorStateMatcher]="macherError">
          <mat-error *ngIf="f.nombre.hasError('required')">Debe ingresar un nombre.</mat-error>
        </mat-form-field>


        <mat-form-field appearance="outline">
          <mat-label>Id de App</mat-label>
          <input matInput formControlName="app_id" type="text" placeholder="Ingrese el id de la App">
          <mat-error *ngIf="f.app_id.hasError('required')">{{getErrorMessage('app_id')}}</mat-error>
        </mat-form-field>
        <app-my-slide-togle [dis]="dis" txtTitulo="Verificacion automatica" txtTrue="Activo" txtFalse="Inactivo"
                            [inputBoolean]="f.verificacion_automatica.value"
                            (outputBolean)="f.verificacion_automatica.setValue($event)"></app-my-slide-togle>

      </div>
      <div class="container"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap="10px"
           fxLayoutGap.xs="0">
        <app-finder-autocomplete [dis]="dis" [item]="f.entidad.value.pais"
                                 [service]="entidadService" columna="nombre_fantasia"
                                 placeHolder="Entidad"
                                 (output)="f.entidad.setValue($event)"></app-finder-autocomplete>
        <app-finder-autocomplete [dis]="dis" [item]="f.aplicacion_tipo.value"
                                 [service]="aplicacionTipoService"
                                 placeHolder="Aplicacion Tipo"
                                 (output)="f.aplicacion_tipo.setValue($event)"></app-finder-autocomplete>
      </div>

      <div class="container"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap="10px"
           fxLayoutGap.xs="0">
      </div>
      <div class="container"
           fxLayout
           fxLayout.xs="column"
           fxLayoutAlign="center"
           fxLayoutGap="10px"
           fxLayoutGap.xs="0">

      </div>


      <div class="button-box" *ngIf="abm">
        <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()"
                          (warnEmiter)="eliminar(formularioAbs.value)"
                          [hideBtnWarn]="!editar" [submitted]="submitted"></app-form-actions>
      </div>
    </form>

  </div>
</mat-card>
